import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline, spotsTakenPercent } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Blocco di urgenza che sta sopra la scheda del prezzo. */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: hours,
    label: 'ore'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  return <div className="rounded-2xl border-2 border-rust bg-paper-soft px-5 py-6 text-center sm:px-7" data-id="element-37" data-mp="1aek6tk7xqxia">
      <p className="flex items-center justify-center gap-2 font-display text-sm font-semibold uppercase tracking-[0.14em] text-rust" data-id="element-38" data-mp="15g0ixe9s7bna">
        <AlarmClockIcon className="h-4 w-4" strokeWidth={2.2} aria-hidden="true" data-id="element-39" data-mp="2zrfeibph45ay" />
        Offerta di lancio — termina tra:
      </p>

      {isExpired ? <p className="mt-4 font-display text-xl font-semibold leading-snug text-ink" data-id="element-40" data-mp="1c2rnlod8il6j">
          L'offerta di lancio è terminata.
        </p> : <>
          <div className="mx-auto mt-5 grid max-w-sm grid-cols-3 gap-2 sm:gap-3" aria-hidden="true" data-id="element-41" data-mp="123aknepdale9">
            {units.map(unit => <div key={unit.label} className="flex flex-col items-center justify-center rounded-xl bg-charcoal px-2 py-3 text-center" data-id="element-42" data-mp="172dfk6bmvb8i">
                <span className="block font-display text-4xl font-bold leading-none text-paper-soft sm:text-5xl" data-id="element-43" data-mp="1utituh1xdvgp">
                  {pad(unit.value)}
                </span>
                <span className="mt-1.5 block font-display text-xs font-medium uppercase tracking-[0.14em] text-paper-deep" data-id="element-44" data-mp="1l0ttoibts40o">
                  {unit.label}
                </span>
              </div>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-45" data-mp="2dnxt87s5fq52">
            Mancano {hours} ore, {minutes} minuti e {seconds} secondi alla fine
            dell'offerta di lancio.
          </p>

          <div className="mt-6 border-t border-line pt-5" data-id="element-46" data-mp="2sbfyp8djcosj">
            <div className="flex items-baseline justify-between gap-4 font-display text-xs font-semibold uppercase tracking-[0.12em] text-ink-muted" data-id="element-47" data-mp="2nd4rl5emkse0">
              <span data-id="element-48" data-mp="2ja84b1e5483q">Posti limitati di lancio</span>
              <span className="text-rust" data-id="element-49" data-mp="2edhq6jlwbmky">Ne restano pochi</span>
            </div>
            <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-paper-deep" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Posti di lancio già presi" data-id="element-50" data-mp="29dvbs6uc00ak">
              <div className="h-full rounded-full bg-rust" style={{
            width: `${spotsTakenPercent}%`
          }} data-id="element-51" data-mp="1znafwr61l9vc" />
            </div>
            <p className="mt-2 text-right font-sans text-xs text-ink-muted" data-id="element-52" data-mp="1vobcxc3vfn6j">
              {spotsTakenPercent}% dei posti presi
            </p>
          </div>
        </>}
    </div>;
}